import React from "react";
import { shuffleGameData } from "../../lib/game-helpers";
import GameGrid from "../GameGrid";
import NumberOfMistakesDisplay from "../NumberMistakes";
import ShareResultsModal from "../modals/ShareResultsModal";

import { PuzzleDataContext } from "../../providers/PuzzleData";
import { GameStatusContext } from "../../providers/GameStatus";
import GameControlButtonsPanel from "../GameButtons";
import { APP_TAGLINE } from "../../lib/constants";
import { puzzleIndex } from "../../lib/time-utils";

function Game() {
    const { gameData } =
        React.useContext(PuzzleDataContext);
    const { submittedGuesses, solvedGameData, isGameOver, isGameWon, numMistakesUsed } =
        React.useContext(GameStatusContext);

    const [shuffledRows, setShuffledRows] = React.useState(
        shuffleGameData({ gameData })
    );
    const [isEndGameModalOpen, setIsEndGameModalOpen] = React.useState(false);
    const [gridShake, setGridShake] = React.useState(false);

    // use effect to update Game Grid after a row has been correctly solved
    React.useEffect(() => {
        const categoriesToRemoveFromRows = solvedGameData.map(
            (data) => data.category
        );
        const dataLeftForRows = gameData.filter((data) => {
            return !categoriesToRemoveFromRows.includes(data.category);
        });
        if (dataLeftForRows.length > 0) {
            setShuffledRows(shuffleGameData({ gameData: dataLeftForRows }));
        }
    }, [solvedGameData, gameData]);

    // Handle End Game!
    React.useEffect(() => {
        if (!isGameOver) {
            return;
        }
        const modalDelay = isGameWon ? 1500 : 500;
        const delayModalOpen = window.setTimeout(() => {
            setIsEndGameModalOpen(true);
        }, modalDelay);

        return () => window.clearTimeout(delayModalOpen);
    }, [isGameOver, isGameWon]);

    return (
        <main className="game-wrapper">
            {/* Game instruction */}
            <p className="text-center text-base font-medium text-gray-700 py-2">
                {APP_TAGLINE}
            </p>

            {/* End game modal */}
            <ShareResultsModal
                isOpen={isEndGameModalOpen}
                onClose={() => setIsEndGameModalOpen(false)}
                isWon={isGameWon}
                submittedGuesses={submittedGuesses}
                gameData={gameData}
                puzzleNumber={puzzleIndex}
                numMistakes={numMistakesUsed}
            />

            {/* Game grid */}
            <GameGrid
                gameRows={shuffledRows}
                shouldGridShake={gridShake}
                setShouldGridShake={setGridShake}
            />

            {/* Game controls */}
            {!isGameOver ? (
                <>
                    <NumberOfMistakesDisplay />
                    <GameControlButtonsPanel
                        shuffledRows={shuffledRows}
                        setShuffledRows={setShuffledRows}
                        setGridShake={setGridShake}
                    />
                </>
            ) : (
                <div className="py-4 text-center">
                    <button
                        onClick={() => setIsEndGameModalOpen(true)}
                        className="text-sm font-medium text-gray-600 hover:text-gray-900 underline underline-offset-2"
                    >
                        View Results
                    </button>
                </div>
            )}
        </main>
    );
}

export default Game;
